import React from 'react';
import { FlowNode } from '../../Types/Types.ts';
import { useAppState } from '../../State.tsx';
import Buttons from '../Buttons/Buttons.tsx';
import PrimaryButton from '../Buttons/PrimaryButton.tsx';
import SecondaryButton from '../Buttons/SecondaryButton.tsx';

import './ResultStep.less';

type ResultStepProps = {
  node: FlowNode;
};

const ResultStep = ({ node }: ResultStepProps) => {
  const { setShowFitAssistant, resetFlow, rearMountedChildBikeSeatsData } = useAppState();
  const cmsStep = rearMountedChildBikeSeatsData?.Steps?.find((stepData) => stepData.Parameter === node.cmsParameter);
  const translations = rearMountedChildBikeSeatsData?.Translations;

  return (
    <>
      <div className="result-step">
        <div className="result-step-content">
          {cmsStep?.ImageUrl && (
            <div className="cms-image-wrapper d-flex justify-content-center w-100 mb-9">
              <img src={cmsStep.ImageUrl} alt={cmsStep.ImageAlt} />
            </div>
          )}
          {cmsStep?.Text && <div dangerouslySetInnerHTML={{ __html: cmsStep.Text }}></div>}
          {cmsStep?.ResultContent && (
            <div className="result-content mt-11">
              <h5 className="mb-4">{translations?.readMore ?? ''}</h5>
              <div className="items">
                {cmsStep?.ResultContent?.map((result, index) => (
                  <div key={index}>
                    <a href={result.Link} target="_blank" rel="noopener noreferrer">
                      <img src={result.ImageUrl} alt={result.ImageAlt} className="mb-4" />
                      {result.LinkText}
                    </a>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
      <Buttons visible>
        <PrimaryButton
          visible
          disabled={false}
          text={translations?.confirm ?? ''}
          onClick={() => setShowFitAssistant(false)}
        />
        <SecondaryButton visible disabled={false} text={translations?.reset ?? ''} onClick={resetFlow} />
      </Buttons>
    </>
  );
};

export default ResultStep;
